import type { ReactNode } from "react";

interface Props {
  admin?: ReactNode;
  extra?: ReactNode;
}

export default function AppFooter({ admin, extra }: Props) {
  return (
    <footer className="mt-8 border-t border-white/10 px-2 pt-4 pb-2 text-center text-[11px] leading-relaxed text-slate-500">
      {(admin || extra) && (
        <div className="mb-3 flex flex-col items-center gap-2">{admin}{extra}</div>
      )}
      <p>Copyright Geiger André 2026</p>
      <p className="mt-1">
        <a href="#impressum" className="underline decoration-slate-700 underline-offset-4 hover:text-slate-300">
          Impressum
        </a>
        <span className="mx-2 text-slate-700">·</span>
        <a href="#datenschutz" className="underline decoration-slate-700 underline-offset-4 hover:text-slate-300">
          Datenschutz
        </a>
      </p>
    </footer>
  );
}
